import { jsx, jsxs } from "react/jsx-runtime";
function EmptyConfigSearch() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 80 80",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("rect", {
                width: "47.6099",
                height: "16.1874",
                transform: "matrix(-1 0 0 1 63.5608 10.0059)",
                fill: "#EFF2F8"
            }),
            /*#__PURE__*/ jsx("rect", {
                width: "47.6099",
                height: "16.1874",
                transform: "matrix(-1 0 0 1 63.5608 31.9062)",
                fill: "#EFF2F8"
            }),
            /*#__PURE__*/ jsx("rect", {
                width: "47.6099",
                height: "16.1874",
                transform: "matrix(-1 0 0 1 63.5608 53.8071)",
                fill: "#EFF2F8"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "8.09369",
                cy: "8.09369",
                r: "8.09369",
                transform: "matrix(-1 0 0 1 24.5207 10.0059)",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "8.09369",
                cy: "8.09369",
                r: "8.09369",
                transform: "matrix(-1 0 0 1 24.5207 31.9062)",
                fill: "#AFB9C9"
            }),
            /*#__PURE__*/ jsx("circle", {
                cx: "8.09369",
                cy: "8.09369",
                r: "8.09369",
                transform: "matrix(-1 0 0 1 24.5207 53.8071)",
                fill: "#D8DEEA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M75.0142 59.9202L57.8746 48.0938L59.3246 69.3556L64.8426 64.3952L67.9882 69.9943L71.2349 68.0418L68.0861 62.4372L75.0142 59.9202Z",
                fill: "#AFB9C9"
            })
        ]
    });
}
export { EmptyConfigSearch as default };
